<template>
  <div class="fancy-grid-stub">
    <!-- FancyGrid placeholder - replace with Vue 3 compatible grid library -->
  </div>
</template>

<script>
export default {
  name: 'FancyGridVue',
  props: {
    config: { type: Object, default: () => ({}) }
  }
}
</script>
